module.exports = __webpack_public_path__ + "static/erasmus3-133bd0fcfa319872aa2143af23894447.png";